import call from "@kinetics254/cassandra-base/service/http";
import constants from "./SetupConstants";

export default {
  namespaced: true,
  state: {
    allocations: [],
    leavePeriod: [],
    leaveTypes: [],
    approvers: [],
    ledgerEntries: [],
    handoverSetup: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    setupGetter: (state) => (setup) => state[setup],
  },
  actions: {
    getAllocations: ({ commit }, params) => {
      call("get", constants.allocations(params))
        .then((response) => {
          commit("MUTATE", { state: "allocations", data: response.data.data });
        })
        .catch((error) => {
          console.log("allocation error", error.response.data.message);
        });
    },
    getLeavePeriod: ({ commit }) => {
      call("get", constants.leavePeriod)
        .then((response) => {
          commit("MUTATE", { state: "leavePeriod", data: response.data.data });
        })
        .catch((error) => {
          console.log("leave period error", error.response.data.message);
        });
    },
    getLeaveTypes: ({ commit }) => {
      call("get", constants.leaveTypes)
        .then((response) => {
          commit("MUTATE", { state: "leaveTypes", data: response.data.data });
        })
        .catch((error) => {
          console.log("leave types error", error.response.data.message);
        });
    },
    getLedgerEntries: ({ commit }, id) => {
      call("get", constants.ledgerEntries(id))
        .then((response) => {
          commit("MUTATE", {
            state: "ledgerEntries",
            data: response.data.data,
          });
        })
        .catch((error) => {
          console.log("ledger entries error", error.response.data.message);
        });
    },
    getHandoverSetup: ({ commit }) => {
      call("get", constants.handoverSetup)
        .then((response) => {
          commit("MUTATE", {
            state: "handoverSetup",
            data: response.data.data,
          });
        })
        .catch((error) => {
          console.log("handover setup error", error.response.data.message);
        });
    },
  },
};
